import PageHeadingWrapper from "./PageHeadingWrapper";
export default PageHeadingWrapper;